module.exports = __webpack_public_path__ + "static/TriDymeIconV1-7ef0f84117501c49660d11f18e77b334.png";